import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApprovedCountries } from '~/App/shared/actions/approvedCountries';
import {
  approvedCountriesStatusSelector,
  approvedCountryCodesSelector
} from '~/App/shared/selectors/approvedCountries';

export const useApprovedCountries = () => {
  const dispatch = useDispatch();
  const status = useSelector(approvedCountriesStatusSelector);
  const approvedCountryCodes = useSelector(approvedCountryCodesSelector);

  const retry = useCallback(() => {
    dispatch(fetchApprovedCountries());
  }, [dispatch]);

  useEffect(() => {
    if (status === 'idle') {
      retry();
    }
  }, [status, retry]);

  return {
    approvedCountryCodes,
    isLoading: status === 'idle' || status === 'pending',
    hasError: status === 'error',
    retry
  };
};
